import Styles from './PublishTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ScheduledPostCard } from './components/ScheduledPostCard'
import { useHandleAction, useSchedulingOptions } from './useSchedulingOptions'
import { Menu } from 'components/Menu/Menu'
import { Section } from '@react-stately/collections'
import { Item } from 'components/Menu/MenuItem'
import { ChevronRightSmall } from 'blaze-ui/icons'
interface MobileSchedulingOptionsProps {
  fileId: string
  scheduledPostId: number
  channel: DesignChannel
}

export const MobileSchedulingOptions = ({ fileId, scheduledPostId, channel }: MobileSchedulingOptionsProps) => {
  const { enabledActions, isScheduledOrPosted } = useSchedulingOptions({ fileId, channel })
  const handleAction = useHandleAction({ fileId, scheduledPostId, channel })
  return (
    <>
      {isScheduledOrPosted && <ScheduledPostCard fileId={fileId} scheduledPostId={scheduledPostId} channel={channel} />}
      {!!enabledActions.length && (
        <>
          <Text variant="label" color="var(--dark-60)">
            {isScheduledOrPosted ? 'More Options' : 'Scheduling Options'}
          </Text>
          <div className={Styles.sectionActions}>
            <Menu menuType="tray" onAction={handleAction}>
              <Section>
                {enabledActions.map((action) => (
                  <Item key={action.key} frontIcon={action.icon} endIcon={ChevronRightSmall}>
                    {action.label}
                  </Item>
                ))}
              </Section>
            </Menu>
          </div>
        </>
      )}
    </>
  )
}
